import React from "react";

export const InformacionProcesoCorto = ({ proceso }) => {
  return (
    <>
     
          <div className="row mb-8">
            <div className="col-lg-3 col-sm-12 ">
              <label>Año del proceso</label>
              <input
                type="text"
                className="form-select mb-5"
                disabled={true}
                defaultValue={proceso.yearProcess}
              />
            </div>
            <div className="col-lg-6 col-sm-12 ">
              <label>Nombre del proceso</label>
              <input
                type="text"
                className="form-control mb-5"
                defaultValue={proceso.name}
                disabled={true}
              />
            </div>
            <div className="col-lg-3 col-sm-12 ">
              <label>Estado</label>
              <input
                type="text"
                className="form-control mb-5"
                defaultValue={proceso.processStatus}
                disabled={true}
              />
            </div>
          </div>
       
    </>
  );
};
